import { render } from "./lang-select-modal.vue?vue&type=template&id=4d017432&ts=true"
import script from "./lang-select-modal.vue?vue&type=script&lang=ts"
export * from "./lang-select-modal.vue?vue&type=script&lang=ts"

import exportComponent from "/mobefind/web/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__